<script>
    /**
     * 下拉选择
     */
    import NormalInput from './NormalInput';
    import NormalScrollbar from './NormalScrollbar.vue';
    import { hideOptsMixin } from '../mixin';

    export default {
        mixins: [hideOptsMixin],
        name: 'drop-down',
        data () {
            return {
                keyword: '',
                optionList: this.options,
                droped: false,
                dropX: 0,
                dropY: 0,
                dropR: 0,
                minWidth: 1,
                hovering: false,
                innerSelected: this.selected,
                useComputeText: '',
                orginOpts: this.options
            };
        },
        watch: {
            selected (v) {
                this.innerSelected = v;
                this.useComputeText = '';
            },
            options (v) {
                this.optionList = v;
                this.orginOpts = v;
            }
        },
        computed: {
            innerSelectedText: {
                get () {
                    if (this.withInput && this.useComputeText) {
                        return this.useComputeText;
                    }
                    const opt = this.withSearch ? this.orginOpts : this.optionList;
                    return this.getSelectedText(this.innerSelected === this.selected ? this.selected : this.innerSelected, opt);
                },
                set (v) {
                    this.useComputeText = v;
                }
            },
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            },
            dropStyle () {
                const style = {
                    opacity: this.dropOpacity,
                    top: this.dropY + 'px',
                    position: this.position
                };
                style.left = `${this.dropX}px`;
                if (this.dropR) {
                    style.right = `${this.dropR}px`;
                } else {
                    style.right = 'unset';
                }
                return style;
            }
        },
        model: {
            prop: 'selected',
            event: 'select'
        },
        props: {
            options: {
                default () {
                    return [];
                },
                required: false
            },

            optionHeight: {
                default: 300,
                required: false
            },
            selected: {
                default: null,
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            placeholder: {
                default: '请选择',
                required: false
            },
            customOptionClass: {
                default: '',
                required: false
            },
            needShowNotOpts:{
                default: false,
                required: false
            },
            /**
             * 选完以后不收起
             */
            notDrop:{
                default: false,
                required: false
            },
            inputPlaceholder: {
                default: '搜索关键词',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            position: {
                default: 'absolute',
                required: false
            },
            withSearch: {
                type: Boolean,
                default: false,
                required: false
            },
            withInput: {
                type: Boolean,
                default: false,
                required: false
            },
            inputType:{
                type: String,
                default: 'text'
            },
            isAutoWidth: {
                type: Boolean,
                default: true,
                required: false
            },
            isAutoClearInput: {
                type: Boolean,
                default: true,
                required: false,
            },
            isWithInputFilter: {
                type: Boolean,
                default: false,
                required: false
            },
            withClearNotInput:{
                type: Boolean,
                default: false,
                required: false
            }
        },
        methods: {
            getSelectedText (v, optionList) {
                optionList = optionList.length ? optionList : this.orginOpts;
                if (optionList.length) {
                    const filterResult = optionList.filter(opt => opt.value === v);
                    return filterResult.length ?
                        (filterResult[0].showText ?
                            filterResult[0].showText :
                            (filterResult[0].orgin_text || filterResult[0].text)) :
                        (this.withInput ? v : '');
                } else {
                    return this.isAutoClearInput ? '' : v;
                }
            },
            drop () {
                if (this.disabled === true) {
                    return false;
                }
                if (this.droped && !this.withInput) {
                    this.fold();
                    return;
                }
                let limitWidth = document.documentElement.clientWidth;
                this.dropR = 0;
                this.droped = true;
                var that = this;
                var rect = this.$el.getBoundingClientRect();
                this.dropX = Math.round(rect.left) + (window.pageXOffset || window.pageXOffset);
                this.dropY = Math.round(rect.top) + 44 + (window.pageYOffset || window.pageYOffset);
                this.minWidth = Math.round(rect.width);

                this.$nextTick(() => {
                    const optRect = this.$refs.optionList.getBoundingClientRect();
                    const optWidth = optRect.width;
                    if (limitWidth - (this.dropX + optWidth) < 80) {
                        this.dropR = 80;
                    }

                    const limitHeight = document.documentElement.clientHeight + window.pageYOffset;
                    if (limitHeight - (optRect.height + optRect.top) < 30) {
                        this.dropY = rect.top + window.pageYOffset - this.$refs.optionList.getBoundingClientRect().height - 7;
                    }
                });

                //  - 28 - 2;
                this.outAreaMouseDown = function () {
                    if (that.hovering) {
                        return;
                    }
                    that.fold();
                };
                window.addEventListener('mousedown', this.outAreaMouseDown);
            },
            fold () {
                this.droped = false;
                window.removeEventListener('mousedown', this.outAreaMouseDown);
            },
            mousedown (item, e) {
                e.stopPropagation();
                this.useComputeText = '';
                this.$emit('select', item.value);
                this.$emit('option-select', item.value);
                if(!this.notDrop){
                    this.innerSelected = item.value;
                    this.fold();
                }
                return false;
            },
            emptyFunc () {
            },
            handleInput () {
                if (!this.orginOpts || !this.orginOpts.length) {
                    this.orginOpts = this.optionList;
                }
                const newOpts = this.$util.deepCopy(this.orginOpts).filter(val => val.text.includes(this.keyword));
                this.optionList = newOpts.map(val => {
                    val.orgin_text = val.orgin_text || val.text;
                    val.text = this.hightLightKw(val.text);
                    return val;
                });
            },
            getFilterText (text) {
                if (text && this.isWithInputFilter) {
                    this.optionList = this.$util.deepCopy(this.orginOpts).filter((v) => {
                        if (this.equal(v.value, text)) {
                            return v;
                        } else {
                            return false;
                        }
                    }).map(val => {
                        val.orgin_text = val.orgin_text || val.text;
                        val.text = this.$util.highLight(val.text, text);
                        return val;
                    });
                } else {
                    this.optionList = this.$util.deepCopy(this.options);
                }
            },
            equal (source, target) {
                return source.toLocaleLowerCase().includes(target.toLocaleLowerCase());
            },
            handleIptInput (v) {
                if (this.withInput) {
                    if (this.isWithInputFilter) {
                        this.getFilterText(v);
                    }
                    this.innerSelected = v;
                    this.$emit('select', v);
                    this.$emit('inputselect', v);
                }
            },
            hightLightKw (name) {
                if (!this.keyword) {
                    return name;
                }
                let replaceStr = '<span style=\'color:#11a1f8\'>$1</span>';
                let reg = new RegExp('(' + this.keyword + ')', 'ig');
                return name.replace(reg, replaceStr);
            },
            handleClearIcon(){
                this.innerSelected='';
                this.useComputeText='';
                this.$emit('select', '');
                this.$emit('clear');
                this.fold();
            }
        },
        beforeDestroy () {
            document.body.removeChild(this.$refs.optionList);
        },
        mounted () {
            document.body.appendChild(this.$refs.optionList);
        },
        components: {
            NormalInput,
            NormalScrollbar
        }
    };
</script>

<template>
    <div class="drop-frame"
         @click.stop="drop"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false"
         v-bind:class="[theme, {disabled: disabled}, {'active': droped}, {disabled:disabled}]"
         v-bind:style="curStyle">
        <normal-input float="none"
                      :is-auto-width="isAutoWidth"
                      :readonly="!withInput"
                      :type='inputType'
                      :placeholder="placeholder"
                      :disabled="disabled"
                      @input="handleIptInput"
                      :clearable="withInput"
                      :suffix-icon="(withClearNotInput || withInput) ? '' : '&#xe69e;'"
                      v-model="innerSelectedText">
        </normal-input>
        <span class="normal-drop-down__suffix icon" v-show='withClearNotInput && innerSelectedText'

            >
                <i @click.stop="handleClearIcon()">&#xe68e;</i>
            </span>
        <transition name="fade">
            <div class="option-list"
                 @mousedown.stop="emptyFunc"
                 ref="optionList"
                 v-show="droped"
                :class="{
                    'with-search': withSearch,
                    [customOptionClass]: !!customOptionClass,
                }"
                 v-bind:style="dropStyle">
                <div class="search-bar" v-if="withSearch">
                    <normal-input
                            class="search-input"
                            v-model="keyword"
                            @input="handleInput"
                            float="none"
                            type="text"
                            autocomplete="off"
                            suffix-icon="&#xe686;"
                            :placeholder="inputPlaceholder"
                    ></normal-input>
                </div>


                <normal-scrollbar :height="optionHeight">
                    <template>
                        <div class="option-list-wrap">
                            <div class="item"
                                 v-for="item in optionList"
                                 :key="item.value"
                                 :class="[{active: innerSelected == item.value} ]"
                                 @mousedown="mousedown(item, $event)"
                                 :title="!notDrop ? item.text : ''"
                                 v-html="item.text"
                                 :style="{'min-width': minWidth + 'px'}">
                            </div>
                        </div>
                        <div class="option-list-wrap" v-if="(keyword || needShowNotOpts) && !optionList.length">
                            <div class="item" :style="{'min-width': minWidth + 'px'}">无匹配结果</div>
                        </div>
                    </template>
                </normal-scrollbar>
            </div>
        </transition>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';


    div.drop-frame.no-border {
        /*display: inline-block;*/
        border-color: transparent;

    }

    .drop-frame {
        position: relative;
        width: auto;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        margin: ((@lineHeight - @widgetsHeight)/2) 0;
        .icon {
            font-style: normal;
            font-family: "cmsicon";
        }
        .normal-drop-down__suffix{
            margin: 11px 10px 10px 10px;
            width: 15px;
            height: 15px;
            line-height: 15px;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
            i{
                font-size: 14px;
                font-style: normal;
                color: #bcbec2;
            }
        }

    }

    .option-list {
        top: 40px;
        left: 40px;
        background-color: #fff;
        box-shadow: 0px 0px 4px 0px rgba(17, 6, 85, 0.16);
        width: auto;
        height: auto;
        min-width: 1px;
        min-height: 1px;
        overflow: auto;
        z-index: 99999;
        padding: 6px 0;
        border-radius: @widgetsBorderRadius;

        .search-bar {
            overflow: hidden;
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
        }

        &.with-search {
            .option-list-wrap {
                height: auto;
            }
        }

        .item {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: auto;
            min-width: 1px;
            overflow: hidden;
            clear: both;
            margin: 0;
            height: @widgetsHeight;
            line-height: @widgetsHeight;
            padding: 0 14px;
            font-size: 14px;
            color: @otherTextClr;
            cursor: pointer;
            box-sizing: border-box;

            &.active {
                color: @primaryBg;
            }
        }

        .item:hover {
            background-color: @otherBtnHoverClr;
        }


    }

</style>
